export default "__VITE_ASSET__BU_ArE1M__"